import { OrderScheduleEntry } from '../../../clients/quipli-service/availability/availability';
import { QuipliLink } from '../../../components/link/quipli-link';
import './schedule-tooltip.scss';

export const OrderScheduleTooltip = ({ orderScheduleEntry }: { orderScheduleEntry: OrderScheduleEntry }) => {
  return (
    <div className="order-tooltip">
      <div>
        <span className="tooltip-label">Order:</span>{' '}
        <QuipliLink to={`orders/view/${orderScheduleEntry.orderId}`} v2Link={true}>
          {orderScheduleEntry.orderNumber}
        </QuipliLink>
      </div>
      <div>
        <span className="tooltip-label">Location:</span> {orderScheduleEntry.location}
      </div>
      <div>
        <span className="tooltip-label">Renter:</span> {orderScheduleEntry.renterName}
      </div>
      <div>
        <span className="tooltip-label">Status:</span> {orderScheduleEntry.orderReturnStatus}
      </div>
      <div>
        <span className="tooltip-label">Start:</span> {orderScheduleEntry.from.toFormat('D t')}
      </div>
      <div>
        <span className="tooltip-label">End:</span> {orderScheduleEntry.to?.toFormat('D t') || 'On Return'}
      </div>
      {orderScheduleEntry.bufferBefore.toMillis() ? (
        <div>
          <span className="tooltip-label">Buffer Before:</span> {orderScheduleEntry.bufferBefore.toHuman()}
        </div>
      ) : undefined}
      {orderScheduleEntry.bufferAfter.toMillis() ? (
        <div>
          <span className="tooltip-label">Buffer After:</span> {orderScheduleEntry.bufferAfter.toHuman()}
        </div>
      ) : undefined}
    </div>
  );
};
